import { FaUserPlus } from "react-icons/fa";

function StaffArchive({
  unArchive_Teacher,
  archived_TeachersPerPage,
  pageIndex_Teachers,
}: any) {
  return (
    <div className="w-full text-center">
      {/* Premium Table Header Deck */}
      <div className="grid grid-cols-5 w-[98%] !min-w-[700px] mb-3 py-3 px-4 bg-slate-50 text-slate-400 text-[10px] font-bold tracking-wider uppercase border-b border-slate-100 rounded-xl text-left items-center">
        <div className="col-span-1 pl-2">Staff Name</div>
        <div className="col-span-1 text-center">Classrooms</div>
        <div className="col-span-1 text-center">Contact</div>
        <div className="col-span-1 text-center">Degree / Qualification</div>
        <div className="col-span-1 text-right pr-6">Record Actions</div>
      </div>

      {archived_TeachersPerPage && (
        <div className="h-full max-h-[55vh] w-[98%] !min-w-[700px] overflow-y-auto register-scroll pr-1 space-y-2">
          {archived_TeachersPerPage.length >= 1 &&
          archived_TeachersPerPage[pageIndex_Teachers] ? (
            archived_TeachersPerPage[pageIndex_Teachers].map(
              (item: any, index: number) => {
                const classroomsText =
                  item.classrooms && item.classrooms.length > 0
                    ? item.classrooms.map((c: any) => c.name).join(", ")
                    : null;

                return (
                  <div
                    key={index}
                    className="grid grid-cols-5 w-full items-center py-3.5 px-4 bg-white border border-slate-100 hover:border-slate-200 hover:shadow-xs rounded-xl transition-all duration-150 text-left text-[13px] font-semibold text-slate-600"
                  >
                    {/* Staff Name Block */}
                    <div className="col-span-1 font-bold text-slate-800 truncate capitalize pl-2">
                      {item.firstname} {item.surname} {item.othername || ""}
                    </div>

                    {/* Classrooms Allocation */}
                    <div className="col-span-1 text-center">
                      {classroomsText ? (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-md font-mono text-xs bg-slate-100 text-slate-700 border border-slate-200">
                          {classroomsText}
                        </span>
                      ) : (
                        <span className="text-slate-300 font-mono">—</span>
                      )}
                    </div>

                    {/* Contact Info */}
                    <div className="col-span-1 text-center">
                      <div className="font-mono text-xs text-slate-600">
                        {item.phone_number || (
                          <span className="text-slate-300">—</span>
                        )}
                      </div>
                      {item.email && (
                        <div
                          className="text-[11px] text-slate-400 truncate max-w-[160px] mx-auto"
                          title={item.email}
                        >
                          {item.email}
                        </div>
                      )}
                    </div>

                    {/* Degree / Qualification */}
                    <div className="col-span-1 text-center text-slate-600 font-medium">
                      {item.degree ? (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs bg-slate-50 text-slate-600 border border-slate-200">
                          {item.degree}
                        </span>
                      ) : (
                        <span className="text-slate-300 font-mono">—</span>
                      )}
                    </div>

                    {/* Unarchive Button Trigger */}
                    <div className="col-span-1 flex justify-end pr-4">
                      <button
                        type="button"
                        onClick={() => unArchive_Teacher(item.id)}
                        className="inline-flex items-center justify-center gap-1.5 px-3.5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold rounded-lg shadow-xs transition-all active:scale-95 cursor-pointer"
                      >
                        <FaUserPlus className="text-[11px]" /> Unarchive
                      </button>
                    </div>
                  </div>
                );
              },
            )
          ) : (
            <div className="text-center py-16 text-slate-400 font-medium text-xs italic bg-white border border-dashed border-slate-200 rounded-xl">
              No historical faculty records matched your query system criteria...
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default StaffArchive;
